export const container = "c1rz3dqo";
export const disclaimer = "d37jhzx";

require("./style.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");